module.exports = __webpack_public_path__ + "static/media/Hombre4.1e9020f3.svg";